module.exports = __webpack_public_path__ + "static/placeholder-feature-3-5437a1937a08921481a9cfc6dcbb6139.jpg";